import React from "react";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  HeadingLevel,
  Media,
  ImageRun,
} from "docx";
import { Button } from "datocms-react-ui";

type StructuredTextTextNode = { text: string };

type StructuredTextNode =
  | { type: "paragraph"; children: StructuredTextTextNode[] }
  | { type: "heading"; level: number; children: StructuredTextTextNode[] };

type Heading = "Heading1" | "Heading2" | "Heading3" | "Heading4" | "Heading5" | "Heading6" | "Title" | undefined;

function convertLevelToHeading(level : number) : Heading {
  const headings : Heading[] = ["Heading1", "Heading2", "Heading3", "Heading4", "Heading5", "Heading6"];
  if (level < headings.length-1) {
    return headings[level+1];
  }
  return "Title";
}

function parseStructuredText(node: StructuredTextNode): Paragraph[] {
  const ret = [];
  if (node.type == "paragraph") {
    const textRuns = node.children.map(t => new TextRun(t.text));
    const paragraph = new Paragraph({
      children: [...textRuns],
    });
    return [paragraph];
  } else if (node.type == "heading") {
    const textRuns = node.children.map(t => new TextRun(t.text));
    const paragraph = new Paragraph({
      children: [...textRuns],
      heading: convertLevelToHeading(node.level)
    });
    return [paragraph];
  } else {
    alert("Cant convert parts of article");
    console.log("Cant convert: ", node);
    return [];
  }
}

type DocContent = StructuredTextNode | string; // string assumed to be an image URL

type Props = {
  title: string;
  body: DocContent[];
};

export const DocxExporter: React.FC<Props> = ({ title, body }) => {

  const generateDocx = async () => {
    const docChildren: Paragraph[] = [];

    // Add title
    docChildren.push(
      new Paragraph({
        text: title,
        heading: HeadingLevel.HEADING_1,
      })
    );
    

    // Add body content
    for (const item of body) {
      if (typeof item === "string") {
        // Assume image URL
        try {
          const res = await fetch(item);
          const blob = await res.blob();
          const arrayBuffer = await blob.arrayBuffer();
          const segments = item.split(".");
          const extension = segments[segments.length-1];
          if (extension != "png" && extension != "jpg" && extension != "gif" && extension != "bmp" && extension != "svg") {
            alert(`Extension ${extension} is not known for one of the images. Sorry. :()`);
            return;
          }
          /*const image = new ImageRun({
            data: arrayBuffer,
            transformation: {
              width: 200,
              height: 200,
            }
          });
          docChildren.push(new Paragraph(image));
          docChildren.push(image);*/
          throw new Error("Testing")
        } catch (err) {
          docChildren.push(
            new Paragraph({
              text: "\n[Image placeholder]\n"
            })
          );
        }
      } else if (item.type != null) {
        docChildren.push(...parseStructuredText(item));
      } else {
        console.log("Can't identify item: ", item)
      }
    }

    const doc = new Document({
      sections: [{ children: docChildren }],
    });

    const blob = await Packer.toBlob(doc);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "exported.docx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return <Button onClick={generateDocx}>Export to docx</Button>;
};
